import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PageShell } from '@/components/page/PageKit';
import { useSEO } from '@/hooks/useSEO';

const quickLinks = [['Pricing', '/pricing'], ['For agencies', '/for-recruiting-agencies'], ['FAQ', '/faq'], ['Contact', '/contact']];

const NotFound = () => {
  const location = useLocation();
  useSEO({ title: 'Page Not Found | Beatview', description: 'The page you are looking for does not exist.', noindex: true });
  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
  }, [location.pathname]);

  return (
    <PageShell reviewed={false}>
      <section className="relative flex min-h-[80vh] items-center overflow-hidden bg-bv-base px-5 pb-20 pt-36">
        <div aria-hidden className="pointer-events-none absolute inset-0">
          <div className="bv-hero-grid absolute inset-0" />
          <div className="absolute left-1/2 top-10 h-[480px] w-[680px] -translate-x-1/2 animate-aurora rounded-full bg-[hsl(var(--hero-highlight-start)/0.16)] blur-[120px]" />
        </div>
        <div className="relative mx-auto max-w-2xl text-center">
          <p className="bv-hero-highlight font-display text-[9rem] font-semibold leading-none tracking-[-0.06em] sm:text-[12rem]">404</p>
          <h1 className="mt-2 font-display text-3xl font-semibold tracking-[-0.03em] text-bv-ink sm:text-4xl">Page not found</h1>
          <p className="mt-4 text-lg text-bv-ink2">The page you're looking for doesn't exist or has been moved. Let's get you back on track.</p>
          <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
            <Button asChild size="lg" className="bv-shine h-12 rounded-xl px-6 font-semibold"><Link to="/"><Home className="h-4 w-4" />Go to homepage</Link></Button>
            <Button asChild size="lg" variant="outline" className="h-12 rounded-xl border-bv-blue-line bg-white px-6 font-semibold text-bv-ink hover:bg-bv-blue-wash hover:text-bv-ink"><Link to="/features">View features <ArrowRight className="h-4 w-4" /></Link></Button>
          </div>
          <nav aria-label="Popular pages" className="mt-10 flex flex-wrap justify-center gap-2">
            {quickLinks.map(([name, href]) => <Link key={href} to={href} className="rounded-full border border-bv-blue-line bg-white px-4 py-2 text-sm font-semibold text-bv-ink2 transition-colors hover:border-transparent hover:bg-bv-ink hover:text-white">{name}</Link>)}
          </nav>
        </div>
      </section>
    </PageShell>
  );
};

export default NotFound;
